import { render } from "./curry-multi-select.vue?vue&type=template&id=07128a65&scoped=true"
import script from "./curry-multi-select.vue?vue&type=script&lang=js"
export * from "./curry-multi-select.vue?vue&type=script&lang=js"

import "./curry-multi-select.vue?vue&type=style&index=0&id=07128a65&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07128a65"]])

export default __exports__